<template>
  <div class="org-select">
    <div class="metadata-label">{{ documentMetadata.metadata.name }}</div>
    <vselect
      ref="textField"
      v-model="localValue"
      :options="filteredOrgUnits"
      label="label"
      :reduce="org => org.id"
      :data-cy="documentMetadata.metadata.key"
    />
  </div>
</template>

<script>
import orgUnitService from "@/services/admin/orgUnitService";
import Auth0Mixin from "../../views/Auth0Mixin";
import metadataMixin from "@/mixins/metadataMixin";

export default {
  name: "OrgUnitMetadata",

  // Use both mixins - metadataMixin for prop handling and Auth0Mixin for auth
  mixins: [metadataMixin, Auth0Mixin],

  props: {
    // documentMetadata is provided by the metadataMixin
    focusOnLoad: Boolean,
    textSelection: Object,
    onClickToFill: Function,
  },

  data() {
    return {
      orgUnits: [],
    };
  },

  methods: {
    async init() {
      this.orgUnits = (await orgUnitService.getList(true)).items;
      this.orgUnits.forEach(o => (o.label = `${o.name} (${o.code})`));
    },
  },

  computed: {
    // localValue is provided by the mixin and emits events on set
    filteredOrgUnits() {
      if (this.documentMetadata.allowedValues == null) return this.orgUnits;

      return this.orgUnits.filter(ou => this.documentMetadata.allowedValues.includes(ou.id));
    },
  },

  watch: {
    textSelection: {
      handler() {
        // has focus?
        if (!this.$refs.textField?.$el?.contains(document.activeElement)) return;

        let q = this.textSelection.text.toLowerCase();

        let matchedOrg = this.orgUnits.find(
          o => o.name.toLowerCase().indexOf(q) >= 0 || o.code.toLowerCase().indexOf(q) >= 0
        );

        if (matchedOrg) {
          this.localValue = matchedOrg.id;
          if (this.onClickToFill) this.onClickToFill();
        }
      },
      deep: true,
    },

    focusOnLoad() {
      if (this.focusOnLoad) {
        this.$refs.textField.$refs.search.focus();
      }
    },
  },

  async created() {
    if (this.documentMetadata.value) {
      this.localValue = parseInt(this.documentMetadata.value);
    }
  },
};
</script>

<style>
.org-select ul {
  padding-left: 0 !important;
}
</style>
